import React from "react";

interface Props {
  error: Error;
  resetErrorBoundary: () => void;
}

const RootErrorFallback: React.FC<Props> = ({ resetErrorBoundary }) => {
  const handleReload = (): void => {
    resetErrorBoundary();
    window.location.reload();
  };

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center min-vh-100 p-4"
      role="alert"
    >
      <h2 className="h5 mb-3">Something went wrong</h2>
      <p className="text-muted mb-3 text-center">
        An unexpected error occurred. Try reloading the page.
      </p>
      <button type="button" className="btn btn-primary" onClick={handleReload}>
        Reload page
      </button>
    </div>
  );
};

export { RootErrorFallback };
